import withStyles from 'react-jss';

import Intro from './component';
import styles from './styles';

export default withStyles(styles)(Intro);
